import { Command, HttpMethod } from "~/extensions/api";
export class GetLatestShinseiCommand extends Command {
    constructor(isForceGetLatest) {
        super(HttpMethod.Get, "latest/shinsei/get");
        this.isForceGetLatest = isForceGetLatest;
    }
    isForceGetLatest = false;
}
